import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { protocolSelectors } from '@telespot/protocols/data-access';

type TMode = 'rois' | 'other';

@Component({
    selector: 'ts-mobile-analysis-panel',
    templateUrl: './mobile-analysis-panel.component.html',
    styleUrls: ['./mobile-analysis-panel.component.scss'],
    standalone: false
})
export class MobileAnalysisPanelComponent {
  @Output() onclose = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  public readonly context$ = this.store.select(protocolSelectors.selectScope);

  private readonly _modeB$ = new BehaviorSubject<TMode>('other');
  readonly mode$ = combineLatest([this._modeB$.asObservable(), this.context$]).pipe(
    map(([mode, context]) => (context === 'sample' ? 'other' : mode)),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  constructor(protected store: Store) {}

  setMode(mode: TMode) {
    this._modeB$.next(mode);
  }

  erase() {
    this.delete.emit();
  }

  close() {
    this.onclose.emit();
  }
}
